import React, { useEffect } from "react";

/// 2.0.1
const androidUrl =
  "https://download.shangshispace.com/VisionSpace.2.1.0.b166.release.apk";
const oldAndroidUrl = androidUrl;
const iosUrl = "https://apps.apple.com/us/app/mookervision/id1645265848";
const macUrl = "https://download.shangshispace.com/VisionSpace.2.1.1.b.3.dmg";

function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
}

function getMobileOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Android
  if (/android|Linux/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  // Mac & iPad pro
  if (userAgent.toUpperCase().indexOf("MAC") >= 0) {
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      return "iOS";
    }
    return "Mac";
  }

  return "unknown";
}

function getAndroidVersion(ua) {
  ua = (ua || navigator.userAgent).toLowerCase();
  let match = ua.match(/android\s([0-9\.]*)/i);
  return match ? match[1] : undefined;
}

let deviceType = getMobileOperatingSystem();

const redirectToDownloadUrl = () => {
  // copy deeplink url into clipboard
  // navigator.clipboard.writeText(deepLinkUrl);
  // redirect to download URL
  if (deviceType == "iOS") {
    window.location.href = iosUrl;
  } else if (deviceType == "Mac" && macUrl) {
    window.location.href = macUrl;
  } else {
    let androidVersion = getAndroidVersion();
    if (androidVersion) {
      let androidVersionNum = parseInt(getAndroidVersion(), 10);
      if (androidVersionNum > 5) {
        window.location.href = androidUrl;
      } else {
        window.location.href = oldAndroidUrl;
      }
    } else {
      window.location.href = androidUrl;
    }
  }
};

const DownloadMookervision = () => {
  const isInWexin = isWeixin();

  // This effect runs once, after the first render
  useEffect(() => {
    // title
    document.title = "看见";
    const logoUrl = "/images/mookervision/favicon.jpg";

    // favicon
    let link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = logoUrl;
    }

    // apple touch icon
    let linkApple = document.querySelector("link[rel~='apple-touch-icon']");
    if (linkApple) {
      linkApple.href = logoUrl;
    }
  }, []);

  useEffect(() => {
    if (!isInWexin) {
      // open deep link
      let urlArr = window.location.href.split("downloadvision");
      // get deep link params
      if (urlArr.length > 1 && urlArr[1] !== "" && urlArr[1] !== "/") {
        let deepLinkParams = "/";
        deepLinkParams = urlArr[1];
        if (deepLinkParams.substr(0, 1) !== "/") {
          deepLinkParams = "/" + deepLinkParams;
        }
        let deepLinkUrl = "mookervision:/" + deepLinkParams;
        window.location = deepLinkUrl;

        // open download url if app not installed
        setTimeout(function () {
          redirectToDownloadUrl();
        }, 2000);
      } else {
        redirectToDownloadUrl();
      }
    }
  }, []);

  return (
    <div class="download-body mookervision">
      {isInWexin && (
        <img
          src="/images/mookervision/wechat-click-arrow.svg"
          loading="lazy"
          alt=""
          class="wechat-click-arrow"
        />
      )}
      <div class="download-content-wrapper">
        <img
          src={
            isInWexin
              ? "/images/mookervision/wechat-click-content.svg"
              : "/images/mookervision/android-download-content.svg"
          }
          loading="lazy"
          alt=""
          class="download-content"
        />
      </div>
    </div>
  );
};

export default DownloadMookervision;
